/**
 * Panier vide (snippet pop-panier-vide) : le bouton « Ajouter » d'une meilleure vente met le produit
 * au panier et rafraîchit le tiroir, sans quitter la page. Délégation sur le document, posée une fois
 * (le tiroir se redessine, ses boutons changent).
 */
import { signalerAjoutPanier } from '@theme/pop-cart';

if (!window.popPanierVide) {
  window.popPanierVide = true;
  document.addEventListener('click', (event) => {
    const bouton = /** @type {HTMLButtonElement|null} */ (
      event.target instanceof Element ? event.target.closest('[data-pop-ajouter]') : null
    );
    if (!bouton || bouton.disabled) return;
    bouton.disabled = true;
    fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(bouton.dataset.popAjouter), quantity: 1 }] }),
    })
      .then((r) => {
        if (!r.ok) throw new Error(String(r.status));
        return signalerAjoutPanier('pop-panier-vide');
      })
      .catch(() => {
        bouton.textContent = 'Réessayer';
        bouton.disabled = false;
      });
  });
}
